var _circle, _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#ffca28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.5,22h-0.53l0.01-0.97c0.008-0.807-0.301-1.567-0.869-2.141S30.787,18,29.98,18H25v-2.277 c0.595-0.346,1-0.984,1-1.723c0-1.105-0.895-2-2-2s-2,0.895-2,2c0,0.738,0.405,1.376,1,1.723V18h-5c-1.654,0-3,1.346-3,3v1h-0.5 c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1H15v2c0,1.654,1.346,3,3,3h11.89c1.637,0,2.983-1.332,3-2.97L32.91,28h0.59 c0.552,0,1-0.448,1-1v-4C34.5,22.448,34.052,22,33.5,22z M30.89,30.01c-0.005,0.546-0.454,0.99-1,0.99H18c-0.551,0-1-0.449-1-1v-9 c0-0.551,0.449-1,1-1h11.98c0.269,0,0.521,0.105,0.71,0.296s0.292,0.445,0.29,0.714L30.89,30.01z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 19,
    y: 23,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 27,
    y: 23,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 21,
    y: 27,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.66d0f9233746abcb79753d7d49d23073.svg";
export { ForwardRef as ReactComponent };